import ScopeTokenValues from "../../parser-tokens/ScopeTokenValues";
import ScopeToken from "../../parser-tokens/ScopeToken";

const logSvc = new WeakMap();

class ScopeTokenFactory {
    constructor($log) {
        if ($log != null) {
            logSvc.set(this, $log);
        }
        else {
            throw new Error("Missing log service dependency");
        }
    }

    toString() {
        return "ScopeTokenBuilder";
    }

    buildToken(tokenValue) {
        return new ScopeToken(logSvc.get(this), tokenValue);
    }

    buildBeginScopeToken() {
        return this.buildToken(ScopeTokenValues.BeginScope);
    }

    buildEndScopeToken() {
        return this.buildToken(ScopeTokenValues.EndScope);
    }

    buildClosedScopeToken() {
        return this.buildToken(ScopeTokenValues.ClosedScope);
    }

}

ScopeTokenFactory.$inject = ["$log"];

export default ScopeTokenFactory;


//////////////////
// WEBPACK FOOTER
// ./src/models/factories/token-factories/ScopeTokenFactory.js
// module id = QeMp
// module chunks = 1